import { computed, unref } from 'vue';
import { useState } from 'vuex-composition-helpers';
import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';

type MapForHotelMinPriceButton = {
    price: number;
}

const storeModuleName = 'mapForHotelMinPriceButton';

export default () => {
    const {
        price,
    } = useState<MapForHotelMinPriceButton>(storeModuleName, ['price']);

    const priceText = computed(() => (unref(price) ? formatNumber(unref(price)) : ''));

    return {
        priceText,
    };
};